import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import {
    EndpointSalesReports,
    createAPIEndpointSalesReports,
} from "../../../Services/ReportsAll/SalesReportService";
import { Calendar } from "primereact/calendar";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

const DeliveryChallanExcel = () => {
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);

    const handleExportExcel = (fromDate, toDate) => {
        const auth = storage.getLocal("user");
        setLoadingExcel(true);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let uniqueNo = `DeliveryChallanRepor${GetDateFormat()}`;
        createAPIEndpointSalesReports()
            .get(
                `${EndpointSalesReports.DeliveryChallanExcel}?strFromDateString=${fromDateRange}&strToDateString=${toDateRange}&CompId=${auth.CompId}`
            )
            .then((val) => {
                if (val.data.length > 0) {
                    downloadExcel(val.data,`${uniqueNo}.xlsx`);
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Delivery Challan to Excel</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        handleExportExcel(fromDate, toDate);
                                    }}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save as Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default DeliveryChallanExcel;
